import { Box, Button, Heading, Input, Stack, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

const Register = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await register(form.username, form.password);
      navigate('/login');
    } catch (err) {
      setError(err.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="gray.100" p={4}>
      <Box w="full" maxW="sm" bg="white" borderWidth="1px" borderColor="gray.200" borderRadius="lg" p={6}>
          <Stack spacing={4}>
            <Box textAlign="center">
              <Heading size="lg">Create Account</Heading>
              <Text color="gray.500">Join Girvi Riddhi</Text>
            </Box>
            {error && <Text color="red.500">{error}</Text>}
            <form onSubmit={handleSubmit}>
              <Stack spacing={3}>
                <Input
                  name="username"
                  placeholder="Username"
                  value={form.username}
                  onChange={handleChange}
                  required
                />
                <Input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={form.password}
                  onChange={handleChange}
                  required
                />
                <Button type="submit" colorScheme="blue" isLoading={loading}>
                  Register
                </Button>
              </Stack>
            </form>
            <Text fontSize="sm" textAlign="center">
              Already have an account? <Link to="/login">Login</Link>
            </Text>
          </Stack>
        </Box>
    </Box>
  );
};

export default Register;
